import { useTranslation } from 'react-i18next'
import { Box, Typography, SvgIcon } from '@mui/material'
import { PropTypes } from 'prop-types'

import SearchIcon from '@hapana/shared/web/styles/assets/svgs/search.svg'

import Loading from '../loading/loading.component'

import { styles } from './table.styles'

const NoDataOrLoadingIndicator = ({ isLoading }) => {
  const { t } = useTranslation('common')
  return (
    <Box sx={styles.emptyContainer}>
      {isLoading ? (
        <Box>
          <Loading label={t('components.table.loading')} />
        </Box>
      ) : (
        <>
          <SvgIcon component={SearchIcon} sx={styles.emptyIcon} />
          <Typography mt={1.5} typography="medium" color="gray.56">
            {t('components.table.emptySearch')}
          </Typography>
        </>
      )}
    </Box>
  )
}

NoDataOrLoadingIndicator.propTypes = {
  isLoading: PropTypes.bool,
}

export default NoDataOrLoadingIndicator
